import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { IMatrizPlanejamentoModel } from '../models/matriz-planejamento.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class MatrizPlanejamentoService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(pesquisa: string, ativo: boolean, simplificado = false): Promise<IBaseModel<IMatrizPlanejamentoModel[]>> {
    let params = new HttpParams();
    params = params.append('pesquisa', pesquisa || '');

    if (ativo !== undefined) {
      params = params.append('ativo', ativo.toString());
    }

    if (simplificado) {
      params = params.append('simplificado', simplificado.toString());
    }

    return this.httpClient
      .get<IBaseModel<IMatrizPlanejamentoModel[]>>(`${this.apiBaseUrl}/matrizPlanejamento`, { params })
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<IMatrizPlanejamentoModel>> {
    return this.httpClient
      .get<IBaseModel<IMatrizPlanejamentoModel>>(`${this.apiBaseUrl}/matrizPlanejamento/${id}`)
      .toPromise();
  }

  public async inserir(data: IMatrizPlanejamentoModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/matrizPlanejamento`, data)
      .toPromise();
  }

  public async atualizar(data: IMatrizPlanejamentoModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/matrizPlanejamento/${data.id}`, data)
      .toPromise();
  }

  public async reativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/matrizPlanejamento/${id}/reativar`, {})
      .toPromise();
  }

  public async inativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/matrizPlanejamento/${id}/inativar`, {})
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/matrizPlanejamento/${id}`, {})
      .toPromise();
  }
}
